function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { EventEmitter } from 'events';
var CLOSE_INTERVAL = 1000;
export function sendToParent(event, data) {
    var _window_opener;
    (_window_opener = window.opener) === null || _window_opener === void 0 ? void 0 : _window_opener.postMessage(JSON.stringify({
        event: event,
        data: data
    }), window.location.origin);
}
var Popup = /*#__PURE__*/ function(EventEmitter) {
    "use strict";
    _inherits(Popup, EventEmitter);
    function Popup(url, param) {
        var width = param.width, height = param.height;
        _class_call_check(this, Popup);
        var _this;
        _this = _call_super(this, Popup), _define_property(_this, "url", void 0), _define_property(_this, "width", void 0), _define_property(_this, "height", void 0), _define_property(_this, "popup", null), _define_property(_this, "handlePopupMessage", function(event) {
            if (event.origin !== window.location.origin) {
                return;
            }
            var payload = null;
            try {
                payload = JSON.parse(event.data);
            } catch (_) {
                return;
            }
            if (payload == null) {
                return;
            }
            _this.emit(payload.event, payload.data);
        });
        _this.url = url;
        _this.width = width;
        _this.height = height;
        return _this;
    }
    _create_class(Popup, [
        {
            key: "open",
            value: function open() {
                var _this = this;
                var top = window.screenY + (window.outerHeight - this.height) / 2;
                var left = window.screenX + (window.outerWidth - this.width) / 2;
                var windowOptions = "width=".concat(this.width, ",height=").concat(this.height, ",top=").concat(top, ",left=").concat(left, ",location=0,menubar=0,scrollbars=1,status=0,toolbar=0,resizable=1");
                this.popup = window.open(this.url, 'Redirecting...', windowOptions);
                if (this.popup == null) {
                    return;
                }
                var interval = setInterval(function() {
                    if (_this.popup == null || _this.popup.closed) {
                        _this.close();
                        clearInterval(interval);
                    }
                }, CLOSE_INTERVAL);
                window.addEventListener('message', this.handlePopupMessage);
            }
        },
        {
            key: "close",
            value: function close() {
                if (this.popup == null) {
                    return;
                }
                try {
                    this.popup.close();
                } catch (_) {}
                this.popup = null;
                window.removeEventListener('message', this.handlePopupMessage);
                this.emit('close');
            }
        }
    ]);
    return Popup;
}(EventEmitter);
export default Popup;
